import copyToClipboard from 'copy-to-clipboard';
import { DataGridRef } from '../types';
import { getSelectedRangeData } from './copy';

function encodeCsvIden(value: unknown): string {
  if (!value) {
    return '';
  }
  const str = typeof value === 'string' ? value : String(value);
  return `"${str.replace(/"/g, '""').replace(/\x00/g, '')}"`;
}

function exportCsv<R>(gridRefContext: DataGridRef<R>) {
  const rangeData = getSelectedRangeData(gridRefContext);
  if (!rangeData) {
    return;
  }

  copyToClipboard(
    rangeData
      .map((data) => {
        return data
          .map((item) => {
            return encodeCsvIden(item);
          })
          .join(',');
      })
      .join('\r\n'),
    {
      format: 'text/plain',
    },
  );
}

export default exportCsv;
